import { render, staticRenderFns } from "./cursoView.vue?vue&type=template&id=c7688422&"
import script from "./cursoView.vue?vue&type=script&lang=js&"
export * from "./cursoView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports